import React from 'react';
import { useTranslation } from 'react-i18next';
import { Namespace } from '@data/utils/enums';
import { AntdTag } from '@ui/components';

const filterColorMap = {
  categories: 'blue',
  sponsors: 'red',
  overall_status: 'green',
  countries: 'purple',
  locations: 'orange',
  more_locations: 'gold',
};

type FilterProps = {
  isDynamic?: boolean;
  name: string;
  onClose?: () => void;
  type: keyof typeof filterColorMap;
};

export const Filter = ({ name, type, isDynamic = false, onClose }: FilterProps) => {
  const { t } = useTranslation([Namespace.ADMIN]);

  return (
    <AntdTag
      closeIcon
      onClose={onClose}
      closable={!!onClose}
      color={filterColorMap[type] || 'cyan'}
      className="m-0 h-8 leading-8 text-xs items-center"
    >
      {isDynamic ? name : t(`trials_library.filters_options.${type}.${name}`)}
    </AntdTag>
  );
};
